var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:_vm.classes,attrs:{"type":_vm.type,"disabled":_vm.isLoading}},[(_vm.isLoading)?_c('div',{staticClass:"button__loader"},[_c('BaseLoaderDefault')],1):_vm._e(),_c('div',{staticClass:"button__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }